import GenericLayout from 'components/GenericLayout'
import Head from 'next/head'
import { useEffect, useState } from 'react'

function EnterprisePage() {
  const [showFrame, setShowFrame] = useState(false)

  useEffect(() => setShowFrame(true), [])
  return (
    <GenericLayout bgColor="bg-white">
      <Head>
        <script src="https://static.airtable.com/js/embed/embed_snippet_v1.js" />
      </Head>
      {showFrame && (
        <div className="min-w-xs md:min-w-md lg:min-w-lg pb-20">
          <iframe
            className="airtable-embed airtable-dynamic-height"
            src="https://airtable.com/embed/shrQfNlDBIosruQoQ?backgroundColor=cyan"
            frameBorder="0"
            width="100%"
            height="1100"
            style={{
              background: 'transparent',
              border: 'border: 1px solid #ccc'
            }}
          />
        </div>
      )}
    </GenericLayout>
  )
}

export default EnterprisePage
